module.exports = require("./pl.d.ts");